import { Components } from "@mui/material/styles";

export const MuiDialogTitle: Components['MuiDialogTitle'] = {
    styleOverrides: {
        root: {
            color: '#005075',
            backgroundColor: 'white',
            borderBottom: '2px solid #0090D1'
        }
    }
};
